import { getVolume, IPlayer, isPlayerReady, setVolume } from "../utils/shaka"
import { useCallback, useEffect, useState } from "react"
import debounce from "lodash.debounce"

export function useVolume(player: IPlayer | null): [number, (value: number) => void] {
  const [localVolume, setLocalVolume] = useState(50)

  function setPlayerVolume(volume: number) {
    setVolume(player, volume)
  }

  useEffect(() => {
    if (!isPlayerReady(player)) {
      return
    }
    const localStorageVolume = localStorage.getItem("FILEBOY_VIDEO_VOLUME")
    if (localStorageVolume) {
      setLocalVolume(Number(localStorageVolume))
    }
  }, [isPlayerReady(player)])

  const debouncedOnChange = useCallback(debounce(setPlayerVolume, 200), [player])

  useEffect(() => {
    if (!isPlayerReady(player)) {
      return
    }
    localStorage.setItem("FILEBOY_VIDEO_VOLUME", String(localVolume))
    const volumeAsDecimal = localVolume / 100
    if (volumeAsDecimal !== getVolume(player)) {
      debouncedOnChange(volumeAsDecimal)
    }
  }, [localVolume])

  function handleChange(newVal: number) {
    setLocalVolume(newVal)
  }

  return [localVolume, handleChange]
}
